<div class="non-renewal-notice-container" *ngIf="nonRenewalPolicies.length && !isAcmic">
  <div class="non-renewal-notice-warning">
      <img src="./assets/img/images/nonrenewal-icon.svg" alt="warning icon">
  </div>
    <div class="non-renewal-notice-text-container">
      <div class="non-renewal-notice-heading-container">
        <p class="non-renewal-notice-text">{{"NON_RENEWAL_NOTICE" | translate}}</p>
      </div>
      <div class="lh-0 non-renewal-vector">
            <svg xmlns="http://www.w3.org/2000/svg" width="698" height="1" viewBox="0 0 698 1" fill="none" style=" width: 100%;">
              <path d="M698 0.5L-7.62939e-06 0.499969" stroke="#E8EBED"/>
            </svg>
      </div>      
      <div *ngIf="nonRenewalPolicies.length === 1">
        <p class="non-renewal-context">{{"YOUR_POLICY" | translate}} <span class="fw-700">{{ nonRenewalPolicies[0]?.policynumber?.policyNumber }}</span> {{"WILL_EXPIRE" | translate}} <span class="fw-700">{{ nonRenewalPolicies[0]?.expDate | date:'MM/dd/yyyy':'shortDate' }}</span> {{"NOTICE_TEXT" | translate}}</p>
      </div>
      <div *ngIf="nonRenewalPolicies.length > 1">
        <p class="non-renewal-context margin-bottom mb-2">{{"MULTIPLE_POLICIES_NOTICE_TEXT" | translate}}</p>
        <ul class="non-renewal-context non-renewal-policy-list">
          <li *ngFor="let policy of nonRenewalPolicies" class="non-renewal-multiple-policy">
            <span class="fw-700">{{ policy?.policynumber?.policyNumber }}</span> {{"EXPIRES_ON" | translate}} <span class="fw-700">{{ policy?.expDate | date:'MM/dd/yyyy':'shortDate' }}</span>
          </li>
        </ul>
      </div>
    </div>
</div>    